import React from 'react';
import { Tooltip, IconButton } from '@ublend-npm/aulaui-next';
import { BlockToolbar as BlockToolbarContainer } from './BlockToolbar.styled';

export type BlockToolbarItem = {
  icon: JSX.Element;

  title: string;

  /* if unset, defaults to the value of title */
  label?: string;

  /* if unset, defaults to true */
  isVisible?: boolean | undefined;

  /* onAction is the higher-level toolbar-specific implementation, which handles
   event propagation automatically */
  onAction?: (e: any) => void;

  /* onClick is passed as-is to onClick in the IconButton */
  onClick?: (e: any) => void;
};

export type BlockToolbarProps = {
  isVisible: boolean;
  items: BlockToolbarItem[];
};

export const BlockToolbar = (props: BlockToolbarProps) => {
  const { isVisible, items } = props;

  const visibleItems = items.map((item) => {
    const visible =
      typeof item.isVisible === 'undefined' ? true : item.isVisible;

    // We want either a basic onClick handler, or an onAction handler which
    // we wrap with some convenience event propagation handling:
    const onClick =
      item.onClick ||
      ((e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!item.onAction) {
          throw new Error(
            'Expected one of onClick or onAction for BlockToolbar item',
          );
        }

        item.onAction(e);
      });

    if (visible) {
      return (
        <Tooltip title={item.title} key={item.title}>
          <span>
            <IconButton
              label={item.label || item.title}
              icon={item.icon}
              type="secondary"
              size="small"
              onClick={onClick}
              disableRipple={false}
            />
          </span>
        </Tooltip>
      );
    }

    return null;
  });

  if (visibleItems.filter((item) => !!item).length === 0) {
    return null;
  }

  return (
    <BlockToolbarContainer
      data-testid="block-toolbar"
      isVisible={isVisible}
      contentEditable={false}
    >
      {visibleItems}
    </BlockToolbarContainer>
  );
};
